// @ts-check
import AutoSelect from './AutoSelect';

export default AutoSelect;
